/* Keep Shopify's native submission and CAPTCHA in control. Only provide feedback. */
(() => {
  if (window.WFContactFormFeedback) {
    window.WFContactFormFeedback.init(document);
    return;
  }

  const forms = new WeakMap();
  const recoveryDelay = 15000;
  let verificationFailed = false;

  const restoreForm = (form) => {
    const state = forms.get(form);
    if (!state) return;
    clearTimeout(state.settleTimer);
    clearTimeout(state.recoveryTimer);
    state.attempted = false;
    form.removeAttribute('aria-busy');
    state.button.removeAttribute('aria-busy');
    state.button.disabled = false;
    state.button.textContent = state.label;
    state.status.textContent = '';
    state.recovery.hidden = true;
  };

  const showRecovery = (form, message) => {
    const state = forms.get(form);
    if (!state || !form.isConnected) return;
    restoreForm(form);
    state.status.textContent = message;
    state.recovery.hidden = false;
  };

  const init = (root) => {
    root.querySelectorAll('.contact-form__form').forEach((form) => {
      if (forms.has(form)) return;
      const button = form.querySelector('[type="submit"]');
      const status = form.querySelector('[data-wf-contact-status]');
      const recovery = form.querySelector('[data-wf-contact-recovery]');
      if (!button || !status || !recovery) return;
      forms.set(form, { button, status, recovery, label: button.textContent.trim() });
    });
  };

  // Capture first, then wait until Shopify's handlers have decided whether to
  // allow submission. A cancelled CAPTCHA submission must not lock the button.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const state = forms.get(form);
    if (!state || !form.checkValidity()) return;
    restoreForm(form);
    state.attempted = true;
    state.settleTimer = setTimeout(() => {
      if (!form.isConnected) return;
      if (event.defaultPrevented) {
        if (verificationFailed) {
          showRecovery(form, state.status.dataset.unavailable);
          return;
        }
        state.status.textContent = state.status.dataset.verifying;
      } else {
        form.setAttribute('aria-busy', 'true');
        state.button.setAttribute('aria-busy', 'true');
        state.button.textContent = state.status.dataset.sendingLabel;
        state.button.disabled = true;
        state.status.textContent = state.status.dataset.sending;
      }
      // Also covers a blocked challenge or stalled navigation, without claiming
      // delivery, changing entered values, auto-submitting or bypassing CAPTCHA.
      state.recoveryTimer = setTimeout(() => {
        showRecovery(form, state.status.dataset.delayed);
      }, recoveryDelay);
    }, 0);
  }, true);

  window.addEventListener('error', (event) => {
    const script = event.target;
    if (!(script instanceof HTMLScriptElement) || script.id !== 'captcha-provider') return;
    verificationFailed = true;
    document.querySelectorAll('.contact-form__form').forEach((form) => {
      const state = forms.get(form);
      if (state?.attempted) showRecovery(form, state.status.dataset.unavailable);
    });
  }, true);

  window.WFContactFormFeedback = { init, restoreForm };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('.contact-form__form').forEach(restoreForm);
  });
})();
